import angular from 'angular';

document.write(require('./view.html').default);

angular.module("merchant.application.page.okta", [
]).controller("merchant.application.page.okta.controller", [
    "$scope", "$controller", "$location", "$window",
    "merchant.application.main.factory.authentication",
    "merchant.application.main.factory.okta",
    function($scope, $controller, $location, $window, Authentication, Okta) {
        $controller("merchant.application.page.controller", {$scope: $scope});


        Okta.handleOktaRedirect()
            .then((redirectResponse) => {
                if (!redirectResponse) {
                    return;
                }
                Authentication.oktaLogin(
                    redirectResponse.username,
                    redirectResponse.accessToken,
                    (success) => {
                        if (!success) {
                            Okta.loginError("SSO_ERROR");
                        } else {
                            Okta.addToTokenManager('idToken', redirectResponse.idToken);
                            Okta.loginError(null);
                        }
                        $location.path("login");
                    });
            });
    }
]);
